import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import AdminLayout from './components/AdminLayout';
import AuthGuard from './components/AuthGuard';
import AdminLogin from './pages/Login/AdminLogin';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users/Users';
import UserDetail from './pages/Users/UserDetail';
import BeliefSupport from './pages/Users/BeliefSupport';
import Beliefs from './pages/Beliefs/Beliefs';
import SupportingBeliefs from './pages/SupportingBeliefs/SupportingBeliefs';
import Thoughts from './pages/Thoughts/Thoughts';
import ThoughtDetail from './pages/Thoughts/ThoughtDetail';
import Feeds from './pages/Feeds/Feeds';
import FeedDetail from './pages/Feeds/FeedDetail';
import FeedSimulation from './pages/Feeds/FeedSimulation';
import AISupportingBeliefs from './pages/AISupportingBeliefs/AISupportingBeliefs';
import AISupportingBeliefDetail from './pages/AISupportingBeliefs/AISupportingBeliefDetail';
import Coupons from './pages/Coupons/Coupons';
import CouponDetail from './pages/Coupons/CouponDetail';
import Invites from './pages/Invites/Invites';
import InviteDetail from './pages/Invites/InviteDetail';
import MassAIPowerUserAction from './pages/MassAIPowerUserAction';
import MassProbabilisticSupportingBeliefAssignment from './pages/MassProbabilisticSupportingBeliefAssignment';
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import BeliefAnalytics from './pages/BeliefAnalytics/BeliefAnalytics';
import { RecentEntitiesProvider } from './contexts/RecentEntitiesContext';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';

function AppContent(): JSX.Element {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';

  return (
    <AuthProvider>
      <div className={`App ${isLoginPage ? 'login-page' : ''}`}>
        <Routes>
          {/* Public route - Login */}
          <Route path="/login" element={<AdminLogin />} />
          
          {/* Protected routes - All admin pages */}
          <Route path="/*" element={
            <AuthGuard>
              <AdminLayout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/users/:id" element={<UserDetail />} />
                  <Route path="/users/:userId/belief/:beliefId" element={<BeliefSupport />} />
                  <Route path="/belief/:beliefId" element={<BeliefSupport />} />
                  <Route path="/beliefs" element={<Beliefs />} />
                  <Route path="/supportingbeliefs" element={<SupportingBeliefs />} />
                  <Route path="/thoughts" element={<Thoughts />} />
                  <Route path="/thoughts/:thoughtId" element={<ThoughtDetail />} />
                  <Route path="/feeds" element={<Feeds />} />
                  <Route path="/feeds/:feedId" element={<FeedDetail />} />
                  <Route path="/feeds/:feedId/simulate" element={<FeedSimulation />} />
                  <Route path="/ai-supporting-beliefs" element={<AISupportingBeliefs />} />
                  <Route
                    path="/ai-supporting-beliefs/:beliefId"
                    element={<AISupportingBeliefDetail />}
                  />
                  <Route path="/MassAIPowerUserAction" element={<MassAIPowerUserAction />} />
                  <Route
                    path="/MassProbabilisticSupportingBeliefAssignment"
                    element={<MassProbabilisticSupportingBeliefAssignment />}
                  />
                  <Route path="/analytics" element={<Analytics />} />
                  <Route path="/beliefanalytics" element={<BeliefAnalytics />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/coupons" element={<Coupons />} />
                  <Route path="/coupons/:id" element={<CouponDetail />} />
                  <Route path="/invites" element={<Invites />} />
                  <Route path="/invites/:id" element={<InviteDetail />} />
                </Routes>
              </AdminLayout>
            </AuthGuard>
          } />
        </Routes>
      </div>
    </AuthProvider>
  );
}

function App(): JSX.Element {
  return (
    <RecentEntitiesProvider>
      <Router>
        <AppContent />
      </Router>
    </RecentEntitiesProvider>
  );
}

export default App;
